<template>
  <form-autocomplete :label="label"
                     :data="search"
                     v-model="val"
                     :disabled="disabled"
                     @select="select"
                     :selected="selected">
  </form-autocomplete>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: null
      },
      value: null,
      name: {
        type: null,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        val: '',
        extractedLabel: this.label || this.$t('interface.chooseDocument')
      }
    },
    methods: {
      search(q) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('Reference/getDocuments', q).then(data => {
            resolve(data.map((document) => {
              return {key: document.id, value: document.registration_number}
            }))
          }).catch(error => reject(error))
        })
      },
      select(item) {
        this.$emit('select', item)
      }
    },
    computed: {
      selected() {
        if (this.value && this.name) {
          return {
            key: this.value,
            value: this.name
          }
        } else return false
      }
    },
    watch: {
      val(value) {
        this.$emit('input', value)
      }
    }
  }
</script>